const mixpanelAlias = user => {
  if (user && user.email && window.mixpanel) window.mixpanel.alias(user.email);
};

const mixpanelTrack = (event, props) => {
  if (window.mixpanel && event && !props) window.mixpanel.track(event);
  else if (window.mixpanel && event && props)
    window.mixpanel.track(event, props);
};

const mixpanelRegister = props => {
  if (window.mixpanel && props) window.mixpanel.register(props);
};

const mixpanelIdentify = user => {
  if (window.mixpanel && user) window.mixpanel.identify(user.email);
};

const mixpanelPeople = props => {
  if (window.mixpanel) window.mixpanel.people.set(props);
};

const mixpanelPeopleSetOnce = event => {
  if (window.mixpanel) window.mixpanel.people.set_once(event);
};

const mixpanelPeopleIncrement = (event, increment) => {
  if (window.mixpanel && event && increment)
    window.mixpanel.people.increment(event, increment);
};

export {
  mixpanelAlias,
  mixpanelTrack,
  mixpanelPeople,
  mixpanelIdentify,
  mixpanelRegister,
  mixpanelPeopleIncrement,
  mixpanelPeopleSetOnce
};
